import { useEffect } from "react";
import { Navigate } from "react-router";
import { useAuthStore } from "../stores/authStore";
import { LandingPage } from "../pages/LandingPage";
import { resolvePostLoginUrl } from "../lib/subdomain";

/**
 * Root route (/).
 * - Unauthenticated → show landing page.
 * - Authenticated → re-run post-login routing logic to ensure the user
 *   is on the correct subdomain for their role.
 */
export function RootRoute() {
  const { accessToken, user } = useAuthStore();

  useEffect(() => {
    if (!accessToken || !user) return;
    const destination = resolvePostLoginUrl({
      platformRole: user.platformRole ?? null,
      defaultEnterpriseSlug: (user as unknown as { defaultEnterpriseSlug?: string }).defaultEnterpriseSlug ?? null,
      accessToken,
    });
    if (destination.startsWith("http")) {
      window.location.href = destination;
    }
  }, [accessToken, user]);

  if (!accessToken || !user) return <LandingPage />;

  const destination = resolvePostLoginUrl({
    platformRole: user.platformRole ?? null,
    defaultEnterpriseSlug: (user as unknown as { defaultEnterpriseSlug?: string }).defaultEnterpriseSlug ?? null,
    accessToken,
  });

  if (!destination.startsWith("http")) {
    return <Navigate to={destination} replace />;
  }

  // Cross-subdomain — useEffect handles the redirect, show nothing while it fires
  return null;
}
